module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "scale-fade"
    }
  }, [_c('wrapper', [_c('video', {
    ref: "video",
    staticClass: "video",
    attrs: {
      "autoplay": _vm.isWeekendEpisode
    },
    on: {
      "timeupdate": _vm.onTimeUpdateListener,
      "loadstart": _vm.onLoadStart,
      "playing": _vm.onPlaying
    },
    slot: "video"
  }, [(_vm.episodeData) ? _c('source', {
    attrs: {
      "src": _vm.videoSrc,
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.episodeData) ? _c('div', {
    slot: "components"
  }, [_vm._l((_vm.episodeData.components), function(game, index) {
    return (_vm.mountGame[index]) ? _c(game.name, {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showGame[index]),
        expression: "showGame[index]"
      }],
      key: index,
      tag: "component",
      attrs: {
        "config": game.config,
        "currentTime": _vm.currentTime
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isTablet && _vm.playButtonIsVisible) ? _c('a', {
    staticClass: "play-button",
    on: {
      "click": _vm.playVideo
    }
  }, [_c('icon', {
    attrs: {
      "color": "white",
      "src": require('@/assets/images/youtube/icon-play.svg')
    }
  })], 1) : _vm._e()])], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd5bfe74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/episodes/Episode.vue
// module id = 715
// module chunks = 64